export default "__VITE_PUBLIC_ASSET__b297058b__"